module.exports = __webpack_public_path__ + "static/img/icon_scan.eb302ae3.png";